<script setup lang="ts">
import NoInputConfirmModal from '@/components/modal/NoInputConfirmModal.vue';
import type { VolunteerConfirmModalProps } from '@/stores/modal';
interface Emits {
  (e: 'confirm'): void;
}

const props = defineProps<VolunteerConfirmModalProps>();
const emit = defineEmits<Emits>();

const handleConfirm = () => {
  props.onConfirm(props.memId);
};
</script>

<template>
  <NoInputConfirmModal
    title="봉사소임 신청"
    message="봉사신청은 모둠장/부서장과<br> 의논 후 신청할 수 있습니다.<br><br>
            의논하셨으면 '확인'을 누르시고<br>
            아직 의논하지 않은 경우 '돌아가기'를<br>누르시면 목록으로 돌아갑니다."
    modal-type="volunteer-confirm"
    confirm-text="확인"
    cancel-text="돌아가기"
    @confirm="handleConfirm"
    :is-submitting="props.isSubmitting"
  />
</template>
